<template>
  <form @submit.prevent="confirm()">
    <div v-if="demande.statusDemande !== 'En attente de réponse' && demande.statusDemande !== 'En cours'">

    <div class="center big-padding" style="font-size: 18px;">
      La demande ne peut pas être annulée car son statut est : {{ demande.statusDemande }}
    </div>

    <div class="buttons">

      <div class="btn btn-primary" v-on:click="$emit('close')">
        Ok
      </div>
    </div>
  </div>
    <div v-if="demande.statusDemande === 'En attente de réponse'  || demande.statusDemande === 'En cours'">

      <div class="center big-padding">
        Souhaitez-vous annuler cette demande ?
      </div>

      <div class="form-group">
        <label for="objetDemande">
          Objet de la demande
        </label>
        <textarea type="text" class="form-control" id="objetDemande" v-model="demande.objet" disabled>
      </textarea>
      </div>
      <br>

      <div class="form-group">
        <label for="maitrise">
          Crée par :
        </label>
        <div class="form-control" id="maitrise">
          {{demande.maitrise_id | maitriseName}}
        </div>
      </div>
      <br>

      <div class="form-group">
        <label for="commentaireAnnulation">
          Commentaire d'annulation
        </label>
        <textarea type="text" class="form-control" id="commentaireAnnulation" v-model="texte" required>
      </textarea>
      </div>

      <div class="buttons">
        <div class="btn btn-primary" v-on:click='confirm()'>
          Confirmer l'annulation
        </div>

        <div class="btn btn-default" v-on:click="$emit('close')">
          Annuler
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import * as demandeStatut from './../../../utils/demandeStatut'

export default {
  props: [
    'demande',
  ],
  data: function () {
    return {
      texte: '',
    }
  },
  methods: {
    confirm: function () {
      this.demande.commentaireAnnulation = this.texte
      //this.demande.commentaireAnnulation.maitrise = {'nom': this.$store.state.maitrise.nom, 'prenom': this.$store.state.maitrise.prenom, 'credential_id': this.$store.state.maitrise.credential_id}
      console.log('canceleed demande mmmmmmmmmmmmmm',this.demande)
      //this.$store.dispatch('disableDemande', {demande: this.demande})
      this.$store.dispatch('cancelDemande', this.demande)
       this.$emit('close')
    },
  },
}
</script>



// WEBPACK FOOTER //
// DemandeDelete.vue?1229c8fb